import React from 'react';
import hoc from './FieldHOC';

class Checkbox extends React.Component{

  constructor(props){
    super(...arguments);
    this.state = {
      checked: typeof props.value !== 'undefined' ? props.value : (props.field.prop('default_checked') || props.field.get('selected') || false)
    };
  }

  onChange(e) {
    this.setState({
      checked: e.target.checked
    });
    this.props.onChange(e.target.checked);
  }

  render(){
    let field = this.props.field;
    return (
      <div className="checkbox">
        <label htmlFor={this.props.name}>
          <input aria-label={this.props.title || field.get('title')} type="checkbox" name={this.props.name} disabled={this.props.disabled} tabIndex={this.props.tabIndex} onChange={this.onChange.bind(this)} checked={this.state.checked} /> {this.props.title || field.get('title')}
          {this.props.errorComponent}
        </label>
      </div>
    );
  }

}

export default hoc(Checkbox);
